'use client';

import React, { FC, useState } from 'react';
import { useController } from 'react-hook-form';
import { FormHelperText } from 'atoms/FormHelperText';
import { IconSVG } from 'atoms/IconSVG';
import { Span } from 'atoms/Typography';
import { FormInput } from 'molecules/Form/FormInput';
import { ITextInput } from 'molecules/Form/FormInput/types';
import { useTranslations } from 'modules/i18n/useTranslations';
import { AllFormFieldTypes } from 'commerce/scayle/auth/types';
import styles from './styles.module.css';

export const Password: FC<Omit<ITextInput, 'name'> & { name?: string }> = ({
  control,
  placeholder,
  name = 'password',
  className,
  ...fieldProps
}) => {
  const t = useTranslations();
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const changeType = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const { field, fieldState } = useController<AllFormFieldTypes>({
    control,
    name,
  });

  return (
    <>
      <FormInput
        isDirty={fieldState.isDirty || !!fieldState.error}
        hasError={!!fieldState.error}
        field={field}
        type={isPasswordVisible ? 'text' : 'password'}
        name={name}
        placeholder={placeholder || t('common.placeholders.password')}
        classes={{ input: className }}
        {...fieldProps}
      />
      {!!fieldState.error && (
        <FormHelperText error>{fieldState.error.message}</FormHelperText>
      )}
      <Span onClick={changeType} className={styles.showPassword}>
        <IconSVG type="eye" className={styles.icon} />
        {isPasswordVisible && t('common.buttons.hide-password')}
        {!isPasswordVisible && t('common.buttons.show-password')}
      </Span>
    </>
  );
};
